import {NgModule} from '@angular/core';
import {Route, RouterModule} from '@angular/router';
import {LayoutComponent} from './layout/layout.component';
import {HomeComponent} from './pages/home/home.component';
import {PagesModule} from './pages/pages.module';
import {BrevoConfigComponent} from './pages/settings/brevo-config/brevo-config.component';
import {DatastoreComponent} from './pages/settings/datastore/datastore.component';
import {ProviderComponent} from './pages/settings/provider/provider.component';
import {ProviderEditComponent} from './pages/settings/provider/provider-edit/provider-edit.component';
import {TableDataComponent} from './pages/tables/table-data/table-data.component';
import {TableSchemaComponent} from './pages/tables/table-schema/table-schema.component';
import {TablesComponent} from './pages/tables/tables.component';
import {EtlComponent} from './pages/etl-v1/etl/etl.component';
import {EtlUpdateComponent} from './pages/etl-v1/etl-update/etl-update.component';
import {EtlTaskPreviewComponent} from './pages/etl-v1/etl-task-preview/etl-task-preview.component';
import {DatastoreDetailsComponent} from './pages/settings/datastore/datastore-details/datastore-details.component';
import {EtlTaskComponent} from './pages/etl-v1/etl-task/etl-task.component';
import {PopupTransactionEmailComponent} from './pages/popup/popup-transaction-email/popup-transaction-email.component';
import {LayoutPopUpComponent} from './layout/pop-up/layout-pop-up.component';
import {StatisticsComponent} from './pages/statistics/statistics.component';
import {CampaignComponent} from './pages/marketing/campaign/campaign.component';
import {CampaignEditComponent} from './pages/marketing/campaign/campaign-edit/campaign-edit.component';
import {CampaignGroupComponent} from './pages/marketing/campaign-group/campaign-group.component';
import {CampaignGroupEditComponent} from './pages/marketing/campaign-group/campaign-group-edit/campaign-group-edit.component';
import {ViewComponent} from './pages/view/view.component';
import {SubscriptionsComponent} from './pages/marketing/subscriptions/subscriptions.component';
import {ContactComponent} from './pages/invoicing/contact/contact.component';
import {ContactEditComponent} from './pages/invoicing/contact/contact-edit/contact-edit.component';
import {UserComponent} from './pages/admin/user/user.component';
import {UserEditComponent} from './pages/admin/user/user-edit/user-edit.component';
import {AccountComponent} from './pages/account/account.component';
import {BlocHtmlComponent} from './pages/marketing/bloc-html/bloc-html.component';
import {BlocEditHtmlComponent} from './pages/marketing/bloc-html/bloc-edit-html/bloc-edit-html.component';
import {TemplateHtmlComponent} from './pages/landing-page/template-html/template-html.component';
import {TemplateEditComponent} from './pages/landing-page/template-html/template-edit/template-edit.component';
import {ConfigurationComponent} from './pages/landing-page/configuration/configuration.component';
import {
    ConfigurationEditComponent
} from './pages/landing-page/configuration/configuration-edit/configuration-edit.component';
import {TransactionalEmailComponent} from './pages/marketing/transactional-email/transactional-email.component';
import {
    TransactionalEditComponent
} from './pages/marketing/transactional-email/transactional-edit/transactional-edit.component';
import {ApiComponent} from './pages/admin/api/api.component';
import {MaintenanceComponent} from './pages/admin/maintenance/maintenance.component';
import {BookingStatusComponent} from './pages/admin/booking-status/booking-status.component';
// import {UserRouteAccessService} from './auth/user-route-access.service';
import {TranslateModule} from '@ngx-translate/core';
import {InvoiceComponent} from './pages/invoicing/invoice/invoice.component';
import {SearchInvoiceComponent} from './pages/invoicing/invoice/search-invoice/search-invoice.component';
import {AuthGuard} from './auth/auth.guard';
import {RoleComponent} from './pages/admin/role/role.component';
import {RoleEditComponent} from './pages/admin/role/role-edit/role-edit.component';
import {ViewEditorComponent} from './pages/view-editor/view-editor.component';
import {ViewItemEditorComponent} from './pages/view-editor/view-item-editor/view-item-editor.component';
import {EtlDictionnaryComponent} from './pages/etl-v1/etl-dictionnary/etl-dictionnary.component';
import {TagsComponent} from './pages/tags/tag/tags.component';
import {TagsEventComponent} from './pages/tags/tags-event/tags-event.component';
import {TagsEventDetailComponent} from './pages/tags/tags-event-detail/tags-event-detail.component';
import {WorkflowComponent} from './pages/workflow/workflow.component';
import {EtlScriptUpdateComponent} from './pages/etl-v1/etl-script-update/etl-script-update.component';
import {EtlExportUpdateComponent} from './pages/etl-v1/etl-export-update/etl-export-update.component';
import {
    EtlExportUpdateDescriptionComponent
} from './pages/etl-v1/etl-export-update/etl-export-update-description/etl-export-update-description.component';
import {
    EtlExportUpdateSearchComponent
} from './pages/etl-v1/etl-export-update/etl-export-update-search/etl-export-update-search.component';
import {
    EtlExportUpdateParamComponent
} from './pages/etl-v1/etl-export-update/etl-export-update-param/etl-export-update-param.component';
import {CompanyComponent} from './pages/invoicing/company/company.component';
import {CompanyEditComponent} from './pages/invoicing/company/company-edit/company-edit.component';
import {RoutePermissionGuard} from './auth/route-permission.guard';
import {RessourcePermissionGuard} from './auth/ressource-permission.guard';
import {ForbiddenErrorComponent} from './pages/forbidden-error/forbidden-error.component';
import {WorkflowDetailsComponent} from './pages/workflow/workflow-details/workflow-details.component';
import {WorkflowBoardComponent} from './pages/workflow/workflow-board/workflow-board.component';
import {TenantTransferComponent} from './pages/tenant-transfer/tenant-transfer.component';
import {SupersetDashboardComponent} from './pages/dashboard/superset-dashboard.component';

export const routes: Route[] = [
    // otherwise redirect to home
    {
        path: 'popup',
        component: LayoutPopUpComponent,
        canActivate: [AuthGuard],
        data: {name: 'dmp'},
        children: [{
            path: 'marketing-email/:tenant/:id/:templateId',
            component: PopupTransactionEmailComponent,
            canActivate: [AuthGuard, RoutePermissionGuard],
            data: {
                title: 'popup-marketing-email',
                requiredPermissions: ['EMAILTRANSACTIONALS.edit']
            }
        }]
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        // canActivate: [UserRouteAccessService],
        data: {name: 'dmp'},
        children: [
            {
                path: '',
                component: HomeComponent,
                canActivate: [AuthGuard],
                // canActivate: [UserRouteAccessService],
                data: {name: 'dashboard'}
            },
            {
                path: 'error/403',
                component: ForbiddenErrorComponent,
                data: {
                    title: 'Accès refusé',
                    hideNavigation: true
                }
            },
            {
                path: 'account',
                component: AccountComponent,
                canActivate: [AuthGuard],
                // canActivate: [UserRouteAccessService],
                data: {name: 'account'}
            },
            {
                path: 'settings',
                children: [
                    {
                        path: 'datastore',
                        component: DatastoreComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {
                            authorities: ['DATASTORE'],
                            requiredPermissions: ['DATASTORES.read']
                        }
                    },
                    {
                        path: 'provider',
                        children: [
                            {
                                path: '',
                                component: ProviderComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {authorities: ['PROVIDERS'], requiredPermissions: ['PROVIDERS.read']}
                            },
                            {
                                path: 'create/:tenant',
                                component: ProviderEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {authorities: ['PROVIDERS'], requiredPermissions: ['PROVIDERS.create']}
                            },
                            {
                                path: 'edit/:tenant/:id',
                                component: ProviderEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {authorities: ['PROVIDERS'], requiredPermissions: ['PROVIDERS.edit']}
                            }
                        ]
                    },
                    {
                        path: 'datastore/:id/:action',
                        component: DatastoreDetailsComponent,
                        canActivate: [AuthGuard, RessourcePermissionGuard],
                        data: {
                            name: 'settings-datastore-details',
                            authorities: ['DATASTORE'],
                            resource: 'DATASTORES'
                        }
                    },
                    {
                        // La création d'un groupe se fait en modale depuis la liste : l'ancienne
                        // URL (favoris, liens existants) y renvoie.
                        path: 'datastore/new',
                        redirectTo: 'datastore',
                        pathMatch: 'full'
                    },
                    {
                        path: 'view-editor',
                        component: ViewEditorComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {
                            name: 'settings-view-editor',
                            authorities: ['DATASTORE'],
                            requiredPermissions: ['DATAVIEWSETTINGS.read']
                        }
                    },
                    {
                        path: 'view-editor/:datastore/:id',
                        component: ViewItemEditorComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {
                            name: 'settings-view-item-editor',
                            authorities: ['DATASTORE'],
                            requiredPermissions: ['DATAVIEWSETTINGS.edit']
                        }
                    },
                    {
                        path: 'tags',
                        component: TagsComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {
                            name: 'settings-tags-editor',
                            authorities: ['DATASTORE'],
                            requiredPermissions: ['TAGS.read']
                        }
                    },
                    {
                        path: 'brevo-config',
                        component: BrevoConfigComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {
                            name: 'settings-brevo-config',
                            requiredPermissions: ['BREVO_CONFIG.read']
                        }
                    }
                ]
            },
            {
                path: 'tables',
                children: [
                    {
                        path: '',
                        component: TablesComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {
                            name: 'table',
                            authorities: ['TABLES'],
                            requiredPermissions: ['TABLES.read']
                        }
                    },
                    {
                        path: ':group/:database/view',
                        component: TableSchemaComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {
                            name: 'table-schema',
                            authorities: ['TABLES'],
                            requiredPermissions: ['TABLES.read']
                        }
                    },
                    {
                        path: ':group/:database/read',
                        component: TableDataComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {
                            name: 'table-data',
                            authorities: ['TABLES'],
                            requiredPermissions: ['TABLES.read']
                        }
                    },
                ]
            },
            {
                path: 'flux', children: [
                    {
                        path: 'import-v1/etl',
                        component: EtlComponent,
                        data: {
                            authorities: ['ROLE_FLUX'],
                            requiredPermissions: ['IMPORTS.read']
                        },
                        canActivate: [AuthGuard, RoutePermissionGuard],
                    }, {
                        path: 'export/etl',
                        component: EtlComponent,
                        data: {
                            authorities: ['ROLE_FLUX'],
                            requiredPermissions: ['EXPORTS.read']
                        },
                        canActivate: [AuthGuard, RoutePermissionGuard],
                    }, {
                        path: 'export/etl/new-script',
                        component: EtlScriptUpdateComponent,
                        data: {
                            authorities: ['ROLE_FLUX'],
                            requiredPermissions: ['EXPORTS.newScript']
                        },
                        canActivate: [AuthGuard, RoutePermissionGuard]
                    }, {
                        path: 'export/etl/new',
                        component: EtlExportUpdateComponent,
                        data: {
                            authorities: ['ROLE_FLUX'],
                            requiredPermissions: ['EXPORTS.create']
                        },
                        children: [
                            {
                                path: '',
                                component: EtlExportUpdateDescriptionComponent
                            }],
                        canActivate: [AuthGuard, RoutePermissionGuard]
                    },
                    {
                        path: 'export/etl-script/:tenant/:id',
                        component: EtlScriptUpdateComponent,
                        data: {
                            authorities: ['ROLE_FLUX'],
                            requiredPermissions: ['EXPORTS.newScript']
                        },
                        canActivate: [AuthGuard, RoutePermissionGuard]
                    }, {
                        path: 'export/etl/:tenant/:id',
                        component: EtlExportUpdateComponent,
                        data: {
                            authorities: ['ROLE_FLUX'],
                            requiredPermissions: ['EXPORTS.edit']
                        },
                        children: [
                            {
                                path: 'description',
                                component: EtlExportUpdateDescriptionComponent
                            },
                            {
                                path: 'search',
                                component: EtlExportUpdateSearchComponent
                            },
                            {
                                path: 'param',
                                component: EtlExportUpdateParamComponent
                            },
                            {path: '', redirectTo: 'description', pathMatch: 'full'}
                        ],
                        canActivate: [AuthGuard, RoutePermissionGuard]
                    }, {
                        path: 'import-v1/etl/new',
                        component: EtlUpdateComponent,
                        data: {
                            authorities: ['ROLE_FLUX'],
                            requiredPermissions: ['IMPORTS.create']
                        },
                        canActivate: [AuthGuard, RoutePermissionGuard],
                    }, {
                        path: 'import-v1/etl/new-script',
                        component: EtlScriptUpdateComponent,
                        data: {
                            authorities: ['ROLE_FLUX'],
                            requiredPermissions: ['IMPORTS.newScript']
                        },
                        canActivate: [AuthGuard, RoutePermissionGuard],
                    },
                    {
                        path: 'import-v1/task',
                        component: EtlTaskComponent,
                        data: {
                            authorities: ['ROLE_FLUX'],
                            requiredPermissions: ['IMPORTS.read', 'EXPORTS.read']
                        },
                        canActivate: [AuthGuard, RoutePermissionGuard],
                    },
                    {
                        path: 'import-v1/task/:tenant/:id',
                        component: EtlTaskPreviewComponent,
                        data: {
                            authorities: ['ROLE_FLUX'],
                            requiredPermissions: ['IMPORTS.read', 'EXPORTS.read']
                        },
                        canActivate: [AuthGuard, RoutePermissionGuard],
                    },
                    {
                        path: 'import-v1/etl/:tenant/:id',
                        pathMatch: 'full',
                        redirectTo: 'import-v1/etl/:tenant/:id/0'
                    },
                    {
                        path: 'import-v1/etl-script/:tenant/:id',
                        component: EtlScriptUpdateComponent,
                        data: {
                            authorities: ['ROLE_FLUX'],
                            requiredPermissions: ['IMPORTS.newScript']
                        },
                        canActivate: [AuthGuard, RoutePermissionGuard]
                    },
                    {
                        path: 'import-v1/etl/:tenant/:id/:step',
                        component: EtlUpdateComponent,
                        data: {
                            authorities: ['ROLE_FLUX'],
                            requiredPermissions: ['IMPORTS.edit']
                        },
                        canActivate: [AuthGuard, RoutePermissionGuard],
                    },
                    {
                        path: 'import-v1/dico',
                        children: [
                            {
                                path: '',
                                component: EtlDictionnaryComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'dico',
                                    requiredPermissions: ['IMPORTS.read']
                                }
                            }
                        ]
                    }]
            },
            {
                path: 'dashboard/superset',
                component: SupersetDashboardComponent,
                canActivate: [AuthGuard, RoutePermissionGuard],
                data: {
                    name: 'dashboard-superset',
                    requiredPermissions: ['SUPERSET_DASHBOARD.read']
                }
            },
            {
                path: 'transfer',
                component: TenantTransferComponent,
                canActivate: [AuthGuard, RoutePermissionGuard],
                data: {
                    name: 'tenant-transfer',
                    requiredPermissions: ['TRANSFERS.read']
                }
            },
            {
                path: 'workflow',
                children: [
                    {
                        path: '',
                        component: WorkflowComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {
                            name: 'workflow',
                            requiredPermissions: ['WORKFLOWS.read']
                        }
                    },
                    {
                        path: ':tenant/:id/:action',
                        component: WorkflowDetailsComponent,
                        canActivate: [AuthGuard, RessourcePermissionGuard],
                        data: {
                            name: 'workflow-details',
                            resource: 'WORKFLOWS'
                        }
                    },
                    {
                        path: 'board/:tenant/:id/:action',
                        component: WorkflowBoardComponent,
                        canActivate: [AuthGuard, RessourcePermissionGuard],
                        data: {
                            name: 'workflow-board',
                            resource: 'WORKFLOWS'
                        }
                    }
                ]
            },
            {
                path: 'marketing',
                children: [
                    {
                        path: 'subscriptions',
                        component: SubscriptionsComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {
                            name: 'marketing-subscriptions',
                            requiredPermissions: ['SUBSCRIPTIONS.read']
                        }
                    },
                    {
                        path: 'marketing-email',
                        children: [
                            {
                                path: '',
                                component: TransactionalEmailComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-email',
                                    requiredPermissions: ['EMAILTRANSACTIONALS.read']
                                }
                            },
                            {
                                path: ':tenant/:partner/new',
                                component: TransactionalEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-email-new',
                                    requiredPermissions: ['EMAILTRANSACTIONALS.create']
                                }
                            },
                            {
                                path: ':tenant/:id/edit',
                                component: TransactionalEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-email-edit',
                                    requiredPermissions: ['EMAILTRANSACTIONALS.edit']
                                }
                            },
                        ]
                    },
                    {
                        path: 'campaign',
                        children: [
                            {
                                path: '',
                                component: CampaignComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-campaign',
                                    requiredPermissions: ['CAMPAIGNS.read']
                                }
                            },
                            {
                                path: 'new/:tenant',
                                component: CampaignEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-campaign-new',
                                    requiredPermissions: ['CAMPAIGNS.create']
                                }
                            },
                            {
                                path: ':tenant/:id',
                                component: CampaignEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-campaign-edit',
                                    requiredPermissions: ['CAMPAIGNS.read']
                                }
                            },
                            {
                                path: ':tenant/:id/edit',
                                component: CampaignEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-campaign-edit',
                                    requiredPermissions: ['CAMPAIGNS.edit']
                                }
                            }]
                    },
                    {
                        path: 'campaign-group',
                        children: [
                            {
                                path: '',
                                component: CampaignGroupComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-campaign-group',
                                    requiredPermissions: ['CAMPAIGNS.read']
                                }
                            },
                            {
                                path: 'new/:tenant',
                                component: CampaignGroupEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-campaign-group-new',
                                    requiredPermissions: ['CAMPAIGNS.create']
                                }
                            },
                            {
                                path: ':tenant/:id',
                                component: CampaignGroupEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-campaign-group-detail',
                                    requiredPermissions: ['CAMPAIGNS.read']
                                }
                            },
                            {
                                path: ':tenant/:id/edit',
                                component: CampaignGroupEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-campaign-group-edit',
                                    requiredPermissions: ['CAMPAIGNS.edit']
                                }
                            }
                        ]
                    },
                    {
                        path: 'template',
                        children: [
                            {
                                path: '',
                                component: BlocHtmlComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-template',
                                    requiredPermissions: ['HTMLBLOCKS.read']
                                }
                            },
                            {
                                // path: 'new',
                                path: 'new/:tenant',
                                component: BlocEditHtmlComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-template-new',
                                    requiredPermissions: ['HTMLBLOCKS.create']
                                }
                            },
                            {
                                path: ':tenant/:id/edit',
                                component: BlocEditHtmlComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'marketing-template-edit',
                                    requiredPermissions: ['HTMLBLOCKS.edit']
                                }
                            },
                        ]
                    }
                ]
            },
            {
                path: 'landing-page',
                children: [
                    {
                        path: 'page',
                        children: [
                            {
                                path: '',
                                component: TemplateHtmlComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'landing-page-template',
                                    requiredPermissions: ['HTML5TEMPLATES.read']
                                }
                            },
                            {
                                path: ':id/edit',
                                component: TemplateEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'landing-page-template-edit',
                                    requiredPermissions: ['HTML5TEMPLATES.edit']
                                }
                            },
                            {
                                path: 'new',
                                component: TemplateEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'landing-page-template-create',
                                    requiredPermissions: ['HTML5TEMPLATES.create']
                                }
                            },
                        ]
                    },
                    {
                        path: 'config',
                        children: [
                            {
                                path: '',
                                component: ConfigurationComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'landing-page-config',
                                    requiredPermissions: ['LANDINGPAGECONFIGURATIONS.read']
                                }
                            },
                            {
                                path: ':id/edit',
                                component: ConfigurationEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'landing-page-config-edit',
                                    requiredPermissions: ['LANDINGPAGECONFIGURATIONS.edit']
                                }
                            },
                            {
                                path: 'new',
                                component: ConfigurationEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'landing-page-config-create',
                                    requiredPermissions: ['LANDINGPAGECONFIGURATIONS.create']
                                }
                            },
                        ]
                    }
                ]
            },
            {
                path: 'statistics',
                component: StatisticsComponent,
                canActivate: [AuthGuard],
                // canActivate: [UserRouteAccessService],
                data: {name: 'statistics-global'}
            },
            {
                path: 'view/:group',
                component: ViewComponent,
                canActivate: [AuthGuard, RoutePermissionGuard],
                data: {
                    name: 'view',
                    requiredPermissions: ['DATAVIEWS.read']
                },
            },
            {
                path: 'tag/event',
                component: TagsEventComponent,
                canActivate: [AuthGuard, RoutePermissionGuard],
                // canActivate: [UserRouteAccessService],
                data: {
                    name: 'tag',
                    requiredPermissions: ['DATAVIEWS.read']
                },
            },
            {
                path: 'tag/event/:tenant/:id/:iteration',
                component: TagsEventDetailComponent,
                canActivate: [AuthGuard, RoutePermissionGuard],
                // canActivate: [UserRouteAccessService],
                data: {
                    name: 'tag',
                    requiredPermissions: ['DATAVIEWS.read']
                },
            },
            {
                path: 'tag/event/:tenant/:id',
                component: TagsEventDetailComponent,
                canActivate: [AuthGuard, RoutePermissionGuard],
                // canActivate: [UserRouteAccessService],
                data: {
                    name: 'tag',
                    requiredPermissions: ['DATAVIEWS.read']
                },
            },
            {
                path: 'apps',
                children: [
                    {
                        path: 'call-for-invoicing',
                        title: 'tiltes.contact.home.title',
                        children: [
                            {
                                path: '',
                                component: InvoiceComponent,
                                canActivate: [AuthGuard],
                                // canActivate: [UserRouteAccessService],
                                data: {name: 'apps-invoice'}
                            },
                            {
                                path: 'create/:tenant',
                                component: SearchInvoiceComponent,
                                canActivate: [AuthGuard],
                                // canActivate: [UserRouteAccessService],
                                data: {name: 'apps-invoice'}
                            },
                            {
                                path: 'view/:tenant/:id',
                                component: SearchInvoiceComponent,
                                canActivate: [AuthGuard],
                                // canActivate: [UserRouteAccessService],
                                data: {name: 'apps-invoice'}
                            }
                        ]
                    }
                ]
            },
            {
                path: 'invoicing',
                children: [
                    {
                        path: 'contact',
                        children: [
                            {
                                path: '',
                                component: ContactComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'invoicing-contact',
                                    requiredPermissions: ['INVOICECONTACTS.read']
                                }
                            },
                            {
                                path: 'create/:tenant',
                                component: ContactEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'invoicing-contact-create',
                                    requiredPermissions: ['INVOICECONTACTS.create']
                                }
                            },
                            {
                                path: 'edit/:tenant/:id',
                                component: ContactEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'invoicing-contact-edit',
                                    requiredPermissions: ['INVOICECONTACTS.edit']
                                }
                            },
                        ]
                    },
                    {
                        path: 'company',
                        children: [
                            {
                                path: '',
                                component: CompanyComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'invoicing-company',
                                    requiredPermissions: ['INVOICECOMPANIES.read']
                                }
                            },
                            {
                                path: 'create/:tenant',
                                component: CompanyEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                // canActivate: [UserRouteAccessService],
                                data: {
                                    name: 'invoicing-company-create',
                                    requiredPermissions: ['INVOICECOMPANIES.create']
                                }
                            },
                            {
                                path: 'edit/:tenant/:id',
                                component: CompanyEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'invoicing-company-edit',
                                    requiredPermissions: ['INVOICECOMPANIES.edit']
                                }
                            },
                        ]
                    }
                ]
            },
            {
                path: 'admin',
                children: [
                    {
                        path: 'role',
                        children: [
                            {
                                path: '',
                                component: RoleComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'admin-role',
                                    requiredPermissions: ['ROLES.read']
                                }
                            },
                            {
                                path: 'create',
                                component: RoleEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'admin-role-create',
                                    requiredPermissions: ['ROLES.create']
                                }
                            },
                            {
                                path: 'edit/:id',
                                component: RoleEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'admin-role-edit',
                                    requiredPermissions: ['ROLES.edit']
                                }
                            }
                        ]
                    },
                    {
                        path: 'user-management',
                        children: [
                            {
                                path: '',
                                component: UserComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'admin-user',
                                    requiredPermissions: ['USERS.read']
                                }
                            },
                            {
                                path: 'create',
                                component: UserEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'admin-user-create',
                                    requiredPermissions: ['USERS.create']
                                }
                            },
                            {
                                path: 'edit/:id/:login',
                                component: UserEditComponent,
                                canActivate: [AuthGuard, RoutePermissionGuard],
                                data: {
                                    name: 'admin-user-edit',
                                    requiredPermissions: ['USERS.edit']
                                }
                            },
                        ]
                    },
                    {
                        path: 'docs',
                        component: ApiComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {
                            name: 'admin-docs',
                            requiredPermissions: ['API.read']
                        }
                    },
                    {
                        path: 'maintenance',
                        component: MaintenanceComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {
                            name: 'maintenance',
                            requiredPermissions: ['API.read']
                        }
                    },
                    {
                        path: 'booking-statuses', component: BookingStatusComponent,
                        canActivate: [AuthGuard, RoutePermissionGuard],
                        data: {name: 'booking-statuses', requiredPermissions: ['TABLES.read']}
                    }
                ]
            }
        ]
    },
];

@NgModule({
    imports: [PagesModule, RouterModule.forChild(routes),

        TranslateModule],
    exports: [RouterModule],
})
export class DmpAdminRoutingModule {
}
